import type { ParkingSpotStatus } from '../../../api/condominiums';

const STATUS_LABELS: Record<ParkingSpotStatus, string> = {
  OCCUPIED: 'Ocupada',
  AVAILABLE: 'Disponível',
  BORROWED: 'Emprestada',
  RENTED: 'Alugada',
};

export function getParkingSpotStatusLabel(status: string): string {
  return STATUS_LABELS[status as ParkingSpotStatus] ?? status;
}

export function getParkingSpotStatusClasses(status: string): {
  border: string;
  bg: string;
  text: string;
} {
  switch (status) {
    case 'OCCUPIED':
      return { border: 'border-danger', bg: 'bg-danger/10', text: 'text-danger' };
    case 'AVAILABLE':
      return { border: 'border-success', bg: 'bg-success/10', text: 'text-success' };
    case 'BORROWED':
      return { border: 'border-warning', bg: 'bg-warning/10', text: 'text-warning' };
    case 'RENTED':
      return { border: 'border-accent', bg: 'bg-accent-soft', text: 'text-accent' };
    default:
      return { border: 'border-separator', bg: 'bg-surface-secondary', text: 'text-foreground' };
  }
}
